var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 354,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 183,
    width: 237,
    height: 354
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-515 -183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M698.53 195.5C590.716 226.295 534.102 276.577 541.076 312.428 548.049 348.278 735.324 370.432 740.371 410.603 745.417 450.774 601.451 510.525 574.108 516.5",
    stroke: "#FFFFFF",
    strokeWidth: 9.29412,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.5 522C546.5 513.992 552.992 507.5 561 507.5 569.008 507.5 575.5 513.992 575.5 522 575.5 530.008 569.008 536.5 561 536.5 552.992 536.5 546.5 530.008 546.5 522Z",
    stroke: "#FFFFFF",
    strokeWidth: 9.29412,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.832 413.096C720.591 405.271 725.929 397.923 733.754 396.682 741.578 395.441 748.927 400.779 750.168 408.604 751.408 416.428 746.071 423.777 738.246 425.018 730.422 426.258 723.073 420.921 721.832 413.096Z",
    stroke: "#FFFFFF",
    strokeWidth: 9.29412,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.5 310.5C516.5 295.036 529.036 282.5 544.5 282.5 559.964 282.5 572.5 295.036 572.5 310.5 572.5 325.964 559.964 338.5 544.5 338.5 529.036 338.5 516.5 325.964 516.5 310.5Z",
    stroke: "#FFFFFF",
    strokeWidth: 9.29412,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.5 194.5C698.5 188.977 702.977 184.5 708.5 184.5 714.023 184.5 718.5 188.977 718.5 194.5 718.5 200.023 714.023 204.5 708.5 204.5 702.977 204.5 698.5 200.023 698.5 194.5Z",
    stroke: "#FFFFFF",
    strokeWidth: 9.29412,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEmpty);
export default __webpack_public_path__ + "static/media/Logo_Empty.1e6339b3bb9fac501acc496d384f20d8.svg";
export { ForwardRef as ReactComponent };